export default __webpack_public_path__ + "static/media/ig_logo.6d9f3a42.svg";